module.exports = __webpack_public_path__ + "img/26_5.2cb17b50.png";